import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-select',
  templateUrl: './signup-type.component.html',
  styleUrls: ['./signup-type.component.scss'],
})
export class SignupTypeComponent implements OnInit {
  selectedType: string;

  constructor(public router: Router) {}

  ngOnInit(): void {}

  onSelect(type: string): void {
    this.selectedType = type;
  }

  goPage(): void {
    this.router.navigate(['../signup?type=', this.selectedType]);
  }
}
